import { useTranslation } from 'react-i18next'
import { Button } from '@repo/ui'
import { BlockIcon24, DoneIcon32 } from '@repo/ui/icons'
import { Abruftoken } from '@/models/Abruftoken'
import { useDialog } from '@/components/common/dialog'
import BfnDenyStandortBestaetigungDialog from '@/features/befehlsnachrichten/components/dialogs/BfnDenyStandortBestaetigungDialog'
import BfnAcceptStandortBestaetigungDialog from '@/features/befehlsnachrichten/components/dialogs/BfnAcceptStandortBestaetigungDialog'

export interface BfnStandortbestaetigungActionsProps {
  abruftoken: Abruftoken
  isStandortGelesen: boolean
  'data-testid': string
}

export default function BfnStandortbestaetigungActions({
  abruftoken,
  isStandortGelesen,
  'data-testid': testId
}: Readonly<BfnStandortbestaetigungActionsProps>) {
  const { t } = useTranslation('bfnDetails')
  const [
    isAcceptStandortBestaetigenDialogOpen,
    openAcceptStandortBestaetigenDialog,
    closeAcceptStandortBestaetigenDialog
  ] = useDialog()
  const [
    isDenyStandortBestaetigenDialogOpen,
    openDenyStandortBestaetigenDialog,
    closeDenyStandortBestaetigenDialog
  ] = useDialog()

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <BfnAcceptStandortBestaetigungDialog
        abruftoken={abruftoken}
        state={isAcceptStandortBestaetigenDialogOpen}
        onClose={closeAcceptStandortBestaetigenDialog}
        data-testid={`${testId}-accept-dialog`}
      />
      <BfnDenyStandortBestaetigungDialog
        abruftoken={abruftoken}
        state={isDenyStandortBestaetigenDialogOpen}
        onClose={closeDenyStandortBestaetigenDialog}
        data-testid={`${testId}-deny-dialog`}
      />
      {isStandortGelesen && (
        <p className="text-sm" data-testid={`${testId}-info-text`}>
          {t('standort_gelesen_erforderlich.info_text')}
        </p>
      )}
      <Button
        variant="brand-primary"
        className="w-full"
        onClick={() => openAcceptStandortBestaetigenDialog()}
        data-testid={`${testId}-accept-button`}
        disabled={isStandortGelesen}
      >
        <DoneIcon32
          className="shrink-0 !-ml-0.25"
          data-testid={`${testId}-accept-button-icon`}
        />
        <span className="pl-0.25" data-testid={`${testId}-accept-button-text`}>
          {t('actions.standort_confirm_button')}
        </span>
      </Button>

      <Button
        variant="secondary-solid"
        className="w-full"
        onClick={() => openDenyStandortBestaetigenDialog()}
        data-testid={`${testId}-deny-button`}
      >
        <BlockIcon24
          className="shrink-0"
          data-testid={`${testId}-deny-button-icon`}
        />
        <span className="pl-0.5" data-testid={`${testId}-deny-button-text`}>
          {t('actions.standort_deny_button')}
        </span>
      </Button>
    </div>
  )
}
